module.exports = __webpack_public_path__ + "img/loginLeft_20220228.d4c00de3.png";